<div class="search-container">
  <input class="search-input" placeholder="Buscar..." autocomplete="off" />
  <div class="search-img">
    <img src="../../../assets/icons/search-white.svg" sizes="1" />
  </div>
</div>
<br />
